<template>
    <v-app-bar bottom app fixed clipped-left dark height="40" id="dashboard-core-footer">
        <v-container>
            <v-row align="center">
                <v-col v-for="(link, i) in links" :key="i" class="text-center mb-sm-0 mb-5" cols="auto">
                    <a :href="link.href" class="mr-0" rel="noopener" target="_blank" v-text="link.text" />
                </v-col>

                <v-spacer class="hidden-sm-and-down" />

                <v-col cols="12" md="auto">
                    <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
                        &copy; 2020-2021 <a :href="CONF_CLIENT_URL" target="_blank">{{ CONF_CLIENT_URL_WRITTEN }}</a> - All rights reserved, made with
                        <v-icon size="18">
                            mdi-heart
                        </v-icon>
                        for a better journey. (<strong>{{ CONF_REVISIONS_NUMBER }}, {{ CONF_VERSION_NUMBER }}</strong>)
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-app-bar>
</template>

<script>
	import {
        CONF_VERSION_NUMBER,
        CONF_REVISIONS_NUMBER,
        CONF_CLIENT,
        CONF_CLIENT_URL,
        CONF_CLIENT_URL_WRITTEN,
        CONF_CLIENT_URL_APPS,
        CONF_CLIENT_URL_APPS_WRITTEN
    } from '../../config';


    export default {
        name: 'CoreFooter',

        /* >>> *************************************************************** / /* Data */
        data: () => ({

            links: [
                {
                    href: CONF_CLIENT_URL_APPS,
                    text: CONF_CLIENT_URL_APPS_WRITTEN
                },
            ],
            // >>> -------------------------- CONFIG
            CONF_VERSION_NUMBER: CONF_VERSION_NUMBER,
            CONF_REVISIONS_NUMBER: CONF_REVISIONS_NUMBER,
            CONF_CLIENT: CONF_CLIENT,
            CONF_CLIENT_URL: CONF_CLIENT_URL,
            CONF_CLIENT_URL_WRITTEN: CONF_CLIENT_URL_WRITTEN,
            CONF_CLIENT_URL_APPS: CONF_CLIENT_URL_APPS,
            CONF_CLIENT_URL_APPS_WRITTEN: CONF_CLIENT_URL_APPS_WRITTEN,

        }) // eof data()
        /* <<< ****************************************************************/

    };
</script>

<style lang="sass">
    #dashboard-core-footer
        a
            color: #ffffff
            font-size: .825rem
            font-weight: 500
            text-decoration: none
            text-transform: uppercase
</style>

<style scoped>
    .theme--dark.v-sheet {
        background-color: #AB3B7A; /* #AB3B7A, #2d3e52 */
        border-color: #AB3B7A;
    }

    .container {
        padding: 0px;
    }
</style>

